import { BehaviorSubject } from 'rxjs';
import { CurrentLocationStatus } from '../types/location';

export const currentLocationStatus = new BehaviorSubject<CurrentLocationStatus>(
  CurrentLocationStatus.NONE,
);
